import { render, staticRenderFns } from "./ProyectosLista.vue?vue&type=template&id=ee992882&scoped=true"
import script from "./ProyectosLista.vue?vue&type=script&lang=js"
export * from "./ProyectosLista.vue?vue&type=script&lang=js"
import style0 from "./ProyectosLista.vue?vue&type=style&index=0&id=ee992882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee992882",
  null
  
)

export default component.exports